/* Presentation only: native tag navigation, Selly pricing and checkout keep ownership. */
(function () {
  'use strict';
  function quote(base, quantity, tiers) {
    if (!Number.isSafeInteger(base) || base < 0 || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 9999) return null;
    var unit = base;
    tiers.slice().sort(function (a, b) { return a.quantity - b.quantity; }).forEach(function (tier) {
      if (quantity >= tier.quantity) unit = tier.cents;
    });
    return {unit: unit, total: unit * quantity};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {quote: quote};
  if (typeof document === 'undefined') return;

  function start() {
    var zh = document.documentElement.lang.toLowerCase().indexOf('zh') === 0;
    var menuButtons = document.querySelectorAll('.toggle-mob-nav');
    var menuOverlay = document.querySelector('#page-overlay');
    var savedOverlayLabel = null;
    var overlayMenuLabeled = false;
    function syncMenu() {
      var open = document.body.classList.contains('show-mobile-nav');
      menuButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', zh ? (open ? '關閉選單' : '開啟選單') : (open ? 'Close menu' : 'Open menu'));
        button.setAttribute('role', 'button');
      });
      if (menuOverlay && open) {
        if (!overlayMenuLabeled) savedOverlayLabel = menuOverlay.getAttribute('aria-label');
        overlayMenuLabeled = true;
        menuOverlay.setAttribute('aria-label', zh ? '關閉選單' : 'Close menu');
      } else if (menuOverlay && overlayMenuLabeled) {
        if (savedOverlayLabel === null) menuOverlay.removeAttribute('aria-label');
        else menuOverlay.setAttribute('aria-label', savedOverlayLabel);
        overlayMenuLabeled = false;
      }
    }
    syncMenu();
    new MutationObserver(syncMenu).observe(document.body, {attributes: true, attributeFilter: ['class']});
    menuButtons.forEach(function (button) {
      button.addEventListener('keydown', function (event) {
        if (event.key === ' ') { event.preventDefault(); button.click(); }
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || event.defaultPrevented || !document.body.classList.contains('show-mobile-nav')) return;
      var unrelatedDialog = event.target.closest && event.target.closest('[role="dialog"],dialog');
      var mobileNav = document.querySelector('#mobile-nav');
      if (unrelatedDialog && (!mobileNav || !mobileNav.contains(unrelatedDialog))) return;
      var toggle = Array.from(menuButtons).find(function (button) { return button.getClientRects().length > 0; });
      if (!toggle) return;
      event.preventDefault();
      toggle.click();
      // The native theme's close handler restores focus after 500ms. Restore
      // the actual menu control afterwards without creating a second state owner.
      setTimeout(function () {
        if (!document.body.classList.contains('show-mobile-nav') && toggle.isConnected && toggle.getClientRects().length) toggle.focus();
      }, 550);
    });

    var summary = document.querySelector('[data-ib-purchase-summary]');
    if (summary) {
      var product = summary.closest('[data-section-type="product-template"]');
      var quantity = product.querySelector('input[name="quantity"]');
      var offers = summary.querySelector('[data-ib-purchase-offers]');
      var total = summary.querySelector('[data-ib-purchase-total]');
      var currency = summary.dataset.currency;
      var base = Number(summary.dataset.baseCents);
      var tiers = [];
      var lastSignature = '';
      function money(cents) { return new Intl.NumberFormat(zh ? 'zh-HK' : 'en-HK', {style: 'currency', currency: currency}).format(cents / 100); }
      function update() {
        var activeCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
        var selectedVariant = product.querySelector('[name="id"]');
        if (!activeCurrency || activeCurrency !== currency || !selectedVariant || selectedVariant.value !== summary.dataset.variantId) { summary.hidden = true; return; }
        summary.hidden = false;
        tiers = [];
        product.querySelectorAll('#tdf_wholesale .tdf_wholesale_level[data-q]').forEach(function (row) {
          var price = row.querySelector('.tdf_money[data-origin-value][data-currency]');
          var q = Number(row.dataset.q);
          var cents = price && Number(price.dataset.originValue);
          if (price && price.dataset.currency === currency && Number.isSafeInteger(q) && q > 1 && Number.isSafeInteger(cents) && cents >= 0 && cents <= base) tiers.push({quantity:q,cents:cents});
        });
        var signature = JSON.stringify(tiers);
        if (signature !== lastSignature || !offers.children.length) {
          lastSignature = signature;
          offers.replaceChildren();
          var single = document.createElement('li');
          single.textContent = zh ? '1瓶 ' + money(base) : '1 bottle ' + money(base);
          offers.appendChild(single);
          tiers.forEach(function (tier) {
            var line = document.createElement('li');
            line.textContent = zh ? tier.quantity + '瓶或以上 ' + money(tier.cents) + '／瓶' : tier.quantity + '+ bottles ' + money(tier.cents) + ' per bottle';
            offers.appendChild(line);
          });
        }
        var q = quantity && /^\d+$/.test(quantity.value.trim()) ? Number(quantity.value) : 0;
        var result = quote(base, q, tiers);
        var label = tiers.length ? (zh ? q + '瓶商品小計 ' : q + (q === 1 ? ' bottle subtotal ' : ' bottles subtotal ')) : (zh ? q + '瓶原價小計（未計數量優惠）' : q + (q === 1 ? ' bottle' : ' bottles') + ' before quantity offers ');
        var text = result ? label + money(result.total) : (zh ? '請輸入有效數量' : 'Enter a valid quantity');
        if (total.textContent !== text) total.textContent = text;
      }
      quantity && quantity.addEventListener('input', update);
      quantity && quantity.addEventListener('change', update);
      product.addEventListener('change', function (event) { if (event.target.name === 'id' || event.target.classList.contains('single-option-selector')) update(); });
      product.addEventListener('click', function (event) { if (event.target.closest('.quantity')) setTimeout(update, 0); });
      // Observe only app insertions/updates; writes to our own summary never retrigger pricing.
      new MutationObserver(function (records) {
        if (records.some(function (record) { return !summary.contains(record.target); })) update();
      }).observe(product, {childList:true, subtree:true, attributes:true, attributeFilter:['data-origin-value','data-currency','data-q']});
      update();
    }

    // Compact the existing mobile rewards launcher only. Open panels keep their own dimensions.
    if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-product')) {
      var attempts = 0;
      function compactRewards() {
        var host = document.querySelector('#wvomniFloatingWidgetWrapper wvomni-floating-widget');
        var root = host && host.shadowRoot;
        if (!root || !root.querySelector('.wvomni-floating-widget--mobile-bottom-left')) return false;
        if (!root.querySelector('#ib-shopping-launcher-style')) {
          var style = document.createElement('style');
          style.id = 'ib-shopping-launcher-style';
          style.textContent = '@media(max-width:767px){.wvomni-floating-widget--mobile-bottom-left{bottom:max(calc(16px + var(--ib-preview-bottom,0px)),env(safe-area-inset-bottom))!important;left:16px!important}.wvomni-floating-widget--mobile-bottom-left .clickable{width:56px!important;height:56px!important;min-width:44px;min-height:44px}.wvomni-floating-widget--mobile-bottom-left .clickable>svg{width:56px!important;height:56px!important}}';
          root.appendChild(style);
        }
        return true;
      }
      if (!compactRewards()) {
        var timer = setInterval(function () { attempts += 1; if (compactRewards() || attempts >= 20) clearInterval(timer); }, 1000);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
}());
